import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { customCell, dateCell, enumFilterCell, GridPanel, translatedCell } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../../../services/api/endpoint";
import { hasPermission } from "../../../../../services/authentication";
import { FollowUpTaskStatus, Permission } from "../../../../../utils/enums";
import { colorCell, colorCellClassName } from "../../../../global/colorCell";
import FollowUpTaskEditor, { getFollowUpTaskStatusColor } from "../../../followup/followUpTask";

import style from "../../../../../assets/editor.module.scss";

interface IProps {
	projectId: number;
	participantId: number;
}

const ProjectParticipantFollowUpTasks: React.FC<IProps> = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<GridPanel
			className={style.tabGrid}
			listEndpoint={Endpoint.ProjectParticipantFollowUpTasksList}
			listUrlArguments={{ projectId: props.projectId, participantId: props.participantId }}
			endpoint={Endpoint.ProjectParticipantFollowUpTasks}
			addScreen={{
				screen: FollowUpTaskEditor,
				isAllowed: hasPermission(Permission.ProjectsUpdate, Permission.ProjectParticipantsUpdate),
				extraProps: { projectId: props.projectId, projectParticipantId: props.participantId }
			}}
			editScreen={{
				screen: FollowUpTaskEditor,
				isAllowed: hasPermission(Permission.ProjectsUpdate, Permission.ProjectParticipantsUpdate),
				extraProps: { projectId: props.projectId, projectParticipantId: props.participantId }
			}}
			delete={{ urlArguments: { projectId: props.projectId, participantId: props.participantId }, isAllowed: hasPermission(Permission.ProjectsUpdate, Permission.ProjectParticipantsUpdate) }}
			localLoader
		>
			<GridColumn
				field="status"
				title={t("projectParticipantFollowUpTaskStatus")}
				cell={customCell(colorCell(true, translatedCell(), getFollowUpTaskStatusColor), colorCellClassName)}
				filterCell={enumFilterCell(FollowUpTaskStatus)}
			/>
			<GridColumn field="creator.fullName" title={t("creator")} />
			<GridColumn field="assignee.fullName" title={t("taskAssignee")} />
			<GridColumn field="subject" title={t("subject")} />
			<GridColumn field="dueDate" title={t("dueDate")} cell={customCell(dateCell("yyyy-MM-dd HH:mm"))} filter="date" />
		</GridPanel>
	);
};

export default ProjectParticipantFollowUpTasks;
